var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"grey lighten-5 my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-my-clients-submenu'),_c('q-agent-commission-datatable',{attrs:{"agent":_vm.user.Agent,"title":"PCS Bonus"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }